<template>
  <div class="box wrapper-payroll-other-payments">
    <div class="title-container is-flex">
      <h4 class="title is-centered is-4 has-text-primary title-payroll-other-payments">
        Otros pagos
      </h4>
      <div class="field is-centered">
        <BTooltip
          class="add-button"
          label="Agregar otro pago"
          type="is-success"
        >
          <a
            class="button add-otherPayment is-success is-rounded"
            @click="$store.commit('payroll/addOtherPaymentRow')"
          >
            <BIcon icon="plus" />
          </a>
        </BTooltip>
      </div>
    </div>
    <BTable
      :data="otherPaymentsWithIndex"
      :columns="columns"
      detailed
      :has-detailed-visible="(row)=>row.otherPaymentType === '004'"
    >
      <template slot-scope="props">
        <BTableColumn
          class="limit-300"
          field="otherPaymentType"
          internal
        >
          <BField>
            <BSelect
              name="otherPaymentType"
              placeholder="Selecciona el tipo"
              :value="props.row.otherPaymentType"
              class="is-fullwidth"
              :disabled="loading"
              :loading="loading"
              required
              @input="onInput(props.row.id, 'otherPaymentType', $event)"
            >
              <option
                v-for="option in otherPaymentTypeCatalog"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </BSelect>
          </BField>
        </BTableColumn>
        <BTableColumn
          field="key"
          internal
        >
          <BField>
            <BInput
              name="key"
              placeholder="Ingresa una clave de identificación"
              :value="props.row.key"
              required
              @input="onInput(props.row.id, 'key', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="concept"
          internal
        >
          <BField>
            <BInput
              name="concept"
              placeholder="Ingresa un concepto de pago"
              :value="props.row.concept"
              required
              @input="onInput(props.row.id, 'concept', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="amount"
          internal
        >
          <BField>
            <BInput
              name="amount"
              placeholder="Ingresa el monto ha pagar"
              type="number"
              min="0"
              step="0.01"
              :value="props.row.amount"
              required
              @input="onInput(props.row.id, 'amount', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          :visible="props.row.otherPaymentType === '002'"
          field="subsidyCaused"
          internal
        >
          <BField>
            <BInput
              name="subsidyCaused"
              placeholder="0.00"
              type="number"
              min="0"
              step="0.01"
              :value="props.row.subsidyCaused"
              required
              @input="onInput(props.row.id, 'subsidyCaused', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          :visible="props.row.otherPaymentType !== '002'"
          field="subsidyCaused"
          internal
        >
          <BField />
        </BTableColumn>
        <BTableColumn
          field="actions"
          internal
        >
          <span class="actions">
            <a
              class="button is-danger"
              @click="$store.commit('payroll/deleteOtherPayment', props.row.id)"
            >
              <BIcon
                icon="delete"
                aria-hidden="true"
              />
            </a>
          </span>
        </BTableColumn>
      </template>
      <template
        slot="detail"
        slot-scope="props"
      >
        <div class="columns">
          <div class="column is-3">
            <BField
              label="Saldo a favor"
              label-for="positiveBalance"
            >
              <BInput
                name="positiveBalance"
                type="number"
                :value="props.row.positiveBalance"
                @input="onInput(props.row.id, 'positiveBalance', $event)"
              />
            </BField>
          </div>
          <div class="column is-3">
            <BField
              label="Año"
              label-for="yearPositiveBalance"
            >
              <BInput
                name="key"
                type="number"
                :value="props.row.yearPositiveBalance"
                @input="onInput(props.row.id, 'yearPositiveBalance', $event)"
              />
            </BField>
          </div>
          <div class="column is-3">
            <BField
              label="Remanente"
              label-for="remainderPositiveBalance"
            >
              <BInput
                name="remainderPositiveBalance"
                type="number"
                :value="props.row.remainderPositiveBalance"
                @input="onInput(props.row.id, 'remainderPositiveBalance', $event)"
              />
            </BField>
          </div>
        </div>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <BIcon
                icon="emoticon-sad"
                size="is-large"
              />
            </p>
            <p>No has agregado otros pagos</p>
          </div>
        </section>
      </template>
    </BTable>
  </div>
</template>

<script>
import { otherPaymentType as otherPaymentTypeCatalog } from '@machete/common-catalogs';

const normalizeCatalog = ({ key, value }) => ({ value: key, label: value });

export default {
  name: 'PayrollOtherPayments',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      otherPaymentTypeCatalog: otherPaymentTypeCatalog.map(normalizeCatalog),
      columns: [
        { field: 'otherPaymentType', label: 'Tipo de otro pago', centered: true },
        { field: 'key', label: 'Clave', centered: true },
        { field: 'concept', label: 'Concepto', centered: true },
        { field: 'amount', label: 'Monto', centered: true },
        { field: 'subsidyCaused', label: 'Subsidio Causado', centered: true },
        { field: 'actions', label: '', centered: true },
      ],
    };
  },
  computed: {
    otherPaymentsWithIndex() {
      return this.$store.state.payroll.otherPayments.map((otherPayment, index) => ({
        ...otherPayment,
        id: index,
      }));
    },
  },
  methods: {
    onInput(index, name, value) {
      this.$store.commit('payroll/changeOtherPayment', { index, name, value });
    },
  },
};
</script>

<style scoped>
.title.is-4 {
  margin-bottom: 0;
}

.header-label {
  padding-right: 0.25rem;
}

.add-button {
  margin-right: 1.5rem;
}

.button.add-otherPayment {
  padding-left: 0.75em!important;
  padding-right: 0.75em!important;
}

.button.add-otherPayment .icon {
  margin-left: calc(-0.375em - 1px)!important;
  margin-right: calc(-0.375em - 1px)!important;
  font-size: inherit!important;
}

.add-otherPayment-label {
  padding-left: .5rem;
}

.title-container {
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.limit-300 {
  width: 300px;
}
</style>
